import React, { useEffect, useState } from 'react'
import axios from '../../../api/axios'
import useAppContext from '../../../hooks/useAppContext'
import { AppContextType } from '../../../context/AppContext'
import { Modal } from 'antd'
import Swal from 'sweetalert2'

const UpdateAnnonce: React.FC<{
  isModalOpen: boolean
  setIsModalOpen: (isModalOpen: boolean) => void
  annonce: { [key: string]: string }
  setAnnonce: (annonce: { [key: string]: string }) => void
}> = ({ isModalOpen, setIsModalOpen, annonce, setAnnonce }) => {
  const { currentAnnonceId, setCurrentAnnonceId } =
    useAppContext() as AppContextType

  const handleOk = async () => {
    await axios
      .put(`/annonce/annonces/${annonce.id}`, { ...annonce })
      .then((response) => {
        Swal.fire({
          icon: 'success',
          title: "Modification d'annonce",
          text: 'Annonce modifiée avec succès.',
          confirmButtonText: 'OK',
        })
      })
      .catch((error) => console.log(error))
    setIsModalOpen(false)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  return (
    <Modal
      title="Modification d'annonce"
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      okButtonProps={{
        'aria-label': 'Modifier',
        style: { backgroundColor: '#2A919D', borderColor: '#2A919D', color: '#FFFFFF'},
      }}
      cancelButtonProps={{ 'aria-label': 'Annuler' }}
    >
      <div>
        <h6 className="border-bottom pb-2 bg-orange">RAISON SOCIALE</h6>

        <p>
          Indiquer la raison sociale de la société ou la dénomination du Cabinet
          de Notaire annonceur ou l'état civil de la personne concernée par
          l'annonce. En option, vous pouvez ajouter une référence client.
        </p>

        <div className="mb-3 row">
          <label htmlFor="denomination" className="col-sm-3 col-form-label">
            Dénomination
          </label>

          <div className="col-sm-9">
            <input
              className="form-control"
              type="text"
              id="denomination"
              value={annonce?.denomination}
              onChange={(event) =>
                setAnnonce({ ...annonce, denomination: event.target.value })
              }
            />
          </div>
        </div>

        <div className="mb-3 row">
          <label htmlFor="reference_client" className="col-sm-3 col-form-label">
            Référence client
          </label>

          <div className="col-sm-9">
            <input
              className="form-control"
              type="text"
              id="reference_client"
              value={annonce?.reference_client}
              onChange={(event) =>
                setAnnonce({ ...annonce, reference_client: event.target.value })
              }
            />
          </div>
        </div>

        <h6 className="border-bottom pb-2">L'ANNONCE</h6>

        <div className="mb-3 row">
          <label htmlFor="textAnnonce" className="col-sm-3 col-form-label">
            Texte de l'annonce
          </label>

          <div className="col-sm-9">
            <textarea
              className="form-control"
              id="textAnnonce"
              rows={3}
              value={annonce?.textAnnonce}
              onChange={(event) =>
                setAnnonce({ ...annonce, textAnnonce: event.target.value })
              }
            ></textarea>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default UpdateAnnonce
